import clsx from 'clsx'

const SectionTitle = ({ children, className, ...props }) => {
  return (
    <h2
      className={clsx(
        'text-base sm:text-lg md:text-xl font-semibold text-text tracking-tight',
        className
      )}
      {...props}
    >
      {children}
    </h2>
  )
}

export default SectionTitle
